export default __webpack_public_path__ + "static/Room-With-A-View--Burj-Al-Arab-Hotel-97e993af0eb2e0ca8c4b8413eebd25c0.jpg";